import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';

const TokenWatcher = ({ setIsLoggedIn }) => {
  const tokenRef = useRef(localStorage.getItem('auth-token'));
  const navigate = useNavigate();
  const isLoggingOutRef = useRef(false);

  const doLogout = () => {
    if (isLoggingOutRef.current) return;
    isLoggingOutRef.current = true;

    Swal.fire({
      icon: 'warning',
      title: 'Session Expired',
      text: 'Logging you out...',
      timer: 1000,
      timerProgressBar: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    setTimeout(() => {
      localStorage.clear();
      setIsLoggedIn(false);
      tokenRef.current = null;
      navigate('/login', { replace: true });
      isLoggingOutRef.current = false;
    }, 1000);
  };

  useEffect(() => {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const res = await originalFetch(...args);

      if (res.status === 401 || res.status === 403) {
        doLogout();
      }
      return res;
    };

    const interceptorId = axios.interceptors.response.use(
      (res) => res,
      (error) => {
        const status = error?.response?.status;
        if (status === 401 || status === 403) {
          doLogout();
        }
        return Promise.reject(error);
      }
    );

    return () => {
      window.fetch = originalFetch;
      axios.interceptors.response.eject(interceptorId);
    };
  }, [navigate, setIsLoggedIn]);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem('auth-token');
      if (currentToken !== tokenRef.current) {
        doLogout();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [navigate, setIsLoggedIn]);

  return null;
};

export default TokenWatcher;
